import { fetchData } from '../utils/netUtils';

const { affiliates } = window.__TBX_ENV__;

class AffiliatesService {
  apiURL: string;
  projectID: string;
  authKey: string;

  /**
   * constructor to Affiliates service instance
   */
  constructor() {
    this.apiURL = affiliates.baseURL;
    this.projectID = affiliates.projectID;
    this.authKey = affiliates.authKey;
  }


  async getActivateProductURL(tbxUserToken?: string, jwtSession?: string, cp?: string) {
    if (tbxUserToken) {
       return `${this.apiURL}/partnergw/affiliates/${this.projectID}/subscription/activate?toolbox_user_token=${tbxUserToken}&cp=${cp}`
    }
    const URL = `${this.apiURL}/bff/${this.projectID}/subscription/activate?cp=${cp}`;
    const options = {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Authorization': `Bearer ${jwtSession}`,
        'Content-Type': 'application/json;charset=utf-8'
      },
    };
    const result = await fetchData(URL, options, 3, 300);
    if (result.error) {
      throw new Error(JSON.stringify(result.error));
    }
    return result?.redirectUrl;
  }

  getBindingInitializationURL() {
    const URL = `${this.apiURL}/processes/${this.projectID}/binding/initiate`;
    return URL;
  }

  getDevices(customerId: string, cp: string){
    const URL = `${this.apiURL}/devices/${this.projectID}/${cp}/${customerId}`;
    const options = {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=utf-8'
      },
    };
    return fetchData(URL, options, 3, 300);
  }

  deleteDevice({deviceToken, customerId, return_url, cp} : {deviceToken: string, customerId: string, return_url: string, cp: string}){
    const URL = `${this.apiURL}/devices/${this.projectID}/${cp}/_deviceManager/${customerId}?${new URLSearchParams({
      devices: deviceToken,
      return_url,
    }).toString()}`;
    const options = {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=utf-8'
      },
    };
    return fetchData(URL, options, 3, 300);
  }

  getProjectConfiguration(tbxUserToken?: string, jwtSession?: string, cpfiltered?: string) {
    const URL = this._getProjectConfigURL(tbxUserToken, jwtSession, cpfiltered);
    const options = {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Authorization': tbxUserToken ? this.authKey : `Bearer ${jwtSession}`,
        'Content-Type': 'application/json;charset=utf-8'
      },
    };

    return fetchData(URL, options, 3, 300);
  }

  _getProjectConfigURL(tbxUserToken?: string, jwtSession?: string, cpfiltered?: string): string {
    const baseUrl = tbxUserToken 
        ? `${this.apiURL}/partnergw/affiliates/subscriptions?toolbox_user_token=${tbxUserToken}`
        : `${this.apiURL}/bff/subscriptions`;

    const url = new URL(baseUrl);

    if (cpfiltered) {
      url.searchParams.set('cp', cpfiltered);
    }

    return url.toString();
  }

  postReactivateProduct(cp: string, body: {}) {
    const URL = `${this.apiURL}/processes/${this.projectID}/${cp}/subscriptions/binding`;
    const options = {
      method: 'POST',
      body: JSON.stringify(body),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=utf-8'
      },
    };

    return fetchData(URL, options, 3, 300);
  }


  async getRecoveryAccountUrl(cp: string, tbxUserToken?: string, jwtSession?: string) {
    let URL = this._getRecoveryAccountUrl(cp, tbxUserToken, jwtSession);
    const options = {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Authorization': tbxUserToken ? this.authKey : `Bearer ${jwtSession}`,
        'Content-Type': 'application/json;charset=utf-8'
      },
    };

    return fetchData(URL, options, 3, 300);
  }

  _getRecoveryAccountUrl(cp: string, tbxUserToken?: string, jwtSession?: string): string {
    const baseUrl = tbxUserToken
        ? `${this.apiURL}/crm/${this.projectID}/${cp}/generatecustomercta?toolbox_user_token=${tbxUserToken}`
        : `${this.apiURL}/bff/${this.projectID}/${cp}/generatecustomercta`

    return baseUrl;
  }

  getHint(cp: string, tbxUserToken?: string, jwtSession?: string) {
    let URL = this._getHintURL(cp, tbxUserToken, jwtSession);
    const options = {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Authorization': jwtSession ? `Bearer ${jwtSession}` : this.authKey,
        'Content-Type': 'application/json;charset=utf-8'
      },
    };

    return fetchData(URL, options, 3, 300);
  }

  _getHintURL(cp: string, tbxUserToken?: string, jwtSession?: string): string {
    const baseUrl = jwtSession
        ? `${this.apiURL}/bff/${this.projectID}/${cp}/generatecustomercta`
        : `${this.apiURL}/crm/${this.projectID}/${cp}/generatecustomercta?toolbox_user_token=${tbxUserToken}`;

    return baseUrl;
  }

  getJwtSession(sessionCode: string) {
    const URL = `${this.apiURL}/bff/token/${sessionCode}`;
    const options = {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Authorization': this.authKey,
        'Content-Type': 'application/json;charset=utf-8'
      },
    };

    return fetchData(URL, options, 3, 300);
  }

  checkJwtSession(jwtSession: string, deviceId: string) {
    try {
      const parts = jwtSession.split('.');
      if (parts.length !== 3) {
        throw new Error('Invalid JWT format');
      }
      
      const payload = JSON.parse(atob(parts[1]));
      
      if (payload.projectId !== this.projectID) {
        throw new Error('Invalid jwt session - projectId mismatch');
      }

      if (payload.deviceId !== deviceId) {
        throw new Error('Invalid jwt session - deviceId mismatch');
      }
      
      return payload;
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Unknown error';
      const error = new Error(JSON.stringify({
        message: errorMessage,
        code: 'JWT-ERR'
      }));
      throw error;
    }
  }

}

export default AffiliatesService;
